export function toCapitalCase(string) {
  return string
    .toLowerCase()
    .replace(/(^|[^a-zA-Z\u00C0-\u017F'])([a-zA-Z\u00C0-\u017F])/g, function(
      m
    ) {
      return m.toUpperCase();
    });
}
